// extracted by mini-css-extract-plugin
var _1 = "webpack-components-shared-IconChecklist-IconChecklist-module__checklist";
export { _1 as "checklist" }
